import { render } from "./App.vue?vue&type=template&id=28f590e8"
const script = {}

import "./App.vue?vue&type=style&index=0&id=28f590e8&lang=less"

import exportComponent from "C:\\Users\\chaoshu0413\\Desktop\\project\\website-shell3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__